/*jslint node: true */
"use strict";

import DataLoader from 'data-loader';
const _parameter = '{0}';

export default class UniProtEntryDataLoader extends DataLoader {
    constructor() {
        super();
        this._previousAccession = _parameter;
    }

    static get observedAttributes() { return ['accession']; }

    connectedCallback() {}

    attributeChangedCallback(name, oldValue, newValue) {
        // name will always be "accession" due to observedAttributes
        this._previousAccession = oldValue || _parameter;
        this._accession = newValue;
        this._initSources();
    }

    _initSources() {
        let sources = this.querySelectorAll('source');
        this._replaceAccessionInSources(sources);
        this.fetch();
    }

    _replaceAccessionInSources(sources) {
        for (let source of sources) {
            source.src = decodeURI(source.src).replace(this._previousAccession, this._accession);
        }
    }

    get accession() {
        return this._accession;
    }

    set accession(acc) {
        this.setAttribute('accession', acc);
    }
}
